import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import { BasesPagination } from '../../controller';
import { EnumMicroApp, EnumOutagePosition } from '../../enums';
import { ISystemMenu } from '../../interface';
import { OutagesNoticeController } from './outagesNotice';
@BindAll()
export class MenuController {
  @observable
  loading = true;

  /**
   * 菜单树
   * @type {Array<Imenu>}
   * @memberof MenuController
   */
  @observable
  MenuTree: Array<ISystemMenu> = [];

  /**
   * 公告
   * @memberof ApplyController
   */
  outagesNoticeController = new OutagesNoticeController();

  /**
   * 菜单 平铺
   * @type {Array<Imenu>}
   * @memberof ApplyController
   */
  Menuflat: Array<Omit<ISystemMenu, 'children'>> = [];

  /**
   * 菜单列表
   * @memberof MenuController
   */
  Menu = new BasesPagination<ISystemMenu>({
    pagination: EnumAPI.idass_get_personal_menu_list,
    // infinite: true,
    paginationParams: {
      defaultCurrent: null,
      defaultPageSize: null,
      response: {
        valueGetter: async (res) => {
          let { menus } = res;
          const outages = await this.outagesNoticeController.getUserOutageMenu(
            EnumOutagePosition.MOBILE_TOP,
          );
          this.Menuflat = menus;
          const dataSource = lodash.map(menus, (menu) => {
            menu.outagesStatus = lodash.includes(outages, menu.id) ? 0 : 1;
            return menu;
          });

          return {
            dataSource,
          };
        },
      },
    },
  });

  /**
   * 转换 path url
   * @param {ISystemMenu} item
   * @return {*}
   * @memberof ApplyController
   */
  toPath(item: ISystemMenu) {
    // 目录
    if (lodash.size(item.childrenIds)) {
      return;
    }
    let path = ``;
    // 外部菜单
    if (item.extJump) {
      path = lodash.trimStart(
        this.pathJoin([item.origin, item.pathname, item.hash]),
        '/',
      );
    } else if (item.origin) {
      // iframe
      path = this.pathJoin([
        EnumMicroApp.IframePage,
        item.code,
        // item.pathname,
        // item.hash,
      ]);
    } else {
      // 微前端
      path = this.pathJoin([
        EnumMicroApp.MicroPage,
        item.baseRoute,
        item.pathname,
        item.hash,
      ]);
    }
    return path || `/${item.id}`;
  }
  /**
   * 拼接Url
   * @param data
   * @returns
   */
  pathJoin(data: Array<string>) {
    data = lodash.compact(
      lodash.map(data, (x) => lodash.trim(lodash.trim(x, '/'))),
    );
    return lodash.join(['', ...data], '/');
  }

  @computed
  get menuCode() {
    return lodash.map(this.Menu.dataSource, 'code');
  }

  onClear() {
    this.Menu.clear();
  }

  /**
   * 初始化菜单
   * @param parentId
   * @param depth
   */
  async onAppInit() {
    // if (!this.loading) {
    //   return console.warn('已初始化完成');
    // }
    await this.Menu.onLoad();
    this.loading = false;
  }

  /**
   * 抽取H5和小程序个人中心菜单的公共方法，过滤菜单列表
   * @param menuList
   * @param that
   */
  // menuList过滤逻辑
  menuListFilter(menuList, that: any) {
    // 遍历过滤menuList，先判断是不是前端控制的菜单，如果是走前端逻辑看是否展示，展示则return true，
    // 如果不是前端控制，就去接口返回的menus里去找有没有相应的code，有则结合customControl判断是否展示
    return lodash.filter(menuList, (item) => {
      // 纯前端控制的菜单
      if (item.clientControl) {
        return lodash.includes(this.clientControl(that), item.key);
      } else {
        // 如果有customControl，就是对接口返回的有权限的菜单，需要前端进一步判断权限
        const extraControl = item?.extraControl ? item.extraControl() : true;
        let menuAuthority = false;
        if (lodash.isArray(item.key)) {
          menuAuthority = lodash.some(item.key, (key) =>
            lodash.includes(that.menuCodes, key),
          );
        } else {
          menuAuthority = lodash.includes(that.menuCodes, item.key);
        }

        // 设置菜单停机状态
        lodash.find(that.menus, (menu) =>
          lodash.isArray(item.key)
            ? lodash.includes(item.key, menu.code)
            : lodash.eq(item.key, menu.code),
        )?.outagesStatus;

        return menuAuthority ? extraControl : menuAuthority;
      }
    });
  }

  // 纯前端控制的菜单，menuList里clientControl为true的菜单
  private clientControl = (that) => {
    let menu: any = [];
    switch (that.buRole) {
      case 'SMB':
        if (that.UserInfo.isL2) break;
        if (that.isSales) {
          menu = lodash.concat(menu, ['invite', 'client']); // 邀请记录、区域客户
        } else if (that.UserInfo.isBusiness) {
          menu = lodash.concat(menu, ['record']); // 商机记录
        }
        break;
      case 'ISG':
        menu = ['card', 'track']; // 我的名片、留资信息追踪
        if (that.isSales) {
          menu = that.UserInfo.isISGReseller
            ? menu
            : lodash.concat(menu, ['t1MyOrganization']); // T1组织申请
        } else if (that.UserInfo.isT1) {
          menu = [];
        }
        break;
    }

    // 是否展示我的海报：个人用户（不包含意向用户以及服务站）
    if (
      that.UserInfo.isMobileLogin &&
      !(that.UserInfo.isIntendedPartner || that.UserInfo.isServiceStation)
    ) {
      menu = lodash.concat(menu, ['poster']);
    }

    // 10位12位账号登录，强制加上个人中心
    if (that.UserInfo.isL2) {
      menu = lodash.concat(menu, ['myinfo-child']);
    }

    // 市场秩序展示
    if (that.UserInfo.marketOrder) {
      menu = lodash.concat(menu, ['marketOrder']);
    }

    // 是否展示我的审批
    if (that.hasExamine) {
      menu = lodash.concat(menu, ['examine']);
    }

    // L1展示积分订单管理
    if (!that.UserInfo.isL2) {
      menu = lodash.concat(menu, ['pointsOrder']);
    }
    return menu;
  };
}
